export var LabelStatus;
(function (LabelStatus) {
    LabelStatus[LabelStatus["PUBLISHED"] = 1] = "PUBLISHED";
    LabelStatus[LabelStatus["DELETED"] = 3] = "DELETED";
})(LabelStatus || (LabelStatus = {}));
//# sourceMappingURL=label.i.js.map